import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import Icon from '../Icons'

const ImageViewer = ({ images, style, getImagesMethod, indexToShow }) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const goBackward = () => {
    if (currentIndex === 0) {
      setCurrentIndex(images.length - 1)
    } else {
      setCurrentIndex(currentIndex - 1)
    }
  }

  const goForward = () => {
    if (images.length - 1 === currentIndex) {
      setCurrentIndex(0)
    } else {
      setCurrentIndex(currentIndex + 1)
    }
  }

  useEffect(() => {
    setCurrentIndex(indexToShow || 0)
  }, [images, indexToShow])

  return (
    <div className="image-viewer" style={style}>
      {images.map((image, index) => (
        <img
          key={image}
          src={getImagesMethod(image)}
          alt={`image${index}`}
          className={currentIndex === index ? 'active' : 'inactive'}
        />
      ))}
      {images.length > 1 ? (
        <div className="image-viewer__toolbar">
          <button onClick={goBackward} className="button backward-button">
            <Icon icon="arrow" fill="#ffffff" />
          </button>
          <button onClick={goForward} className="button forward-button">
            <Icon icon="arrow" fill="#ffffff" />
          </button>
        </div>
      ) : null}
    </div>
  )
}

ImageViewer.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string),
  getImagesMethod: PropTypes.func,
  style: PropTypes.object,
  indexToShow: PropTypes.number,
}

export default ImageViewer
